import { Stack, Typography } from '@mui/material';
import { ISourcingCompanyRow } from '../../../schemas/SourcingListItems.schema';
import { FMT } from '../../../util/formatter-service';
import { NumericFormatterId } from '../../../util/formatters/NumericFormatters';
import { DetailRow } from './DetailRow';
import { sectionCss, sectionTitleCss } from './sourcing-detail-panel.styles';

export interface FundingSectionProps {
  readonly data: ISourcingCompanyRow;
}

export function FundingSection({ data }: FundingSectionProps) {
  return (
    <Stack css={sectionCss} gap='4px'>
      <Typography css={sectionTitleCss}>Funding</Typography>
      <Stack gap='4px'>
        <DetailRow
          label='Total Raised'
          value={
            data.totalFunding != null ? FMT.format(NumericFormatterId.currency0Dp, data.totalFunding) : null
          }
        />
        <DetailRow
          label='Last Funding Raised'
          value={
            data.lastFundingRaised != null
              ? FMT.format(NumericFormatterId.currency0Dp, data.lastFundingRaised)
              : null
          }
        />
        <DetailRow
          label='Post Valuation'
          value={
            data.postValuation != null ? FMT.format(NumericFormatterId.currency0Dp, data.postValuation) : null
          }
        />
        <DetailRow label='All Investors' value={data.allInvestors?.join(', ')} />
      </Stack>
    </Stack>
  );
}
